















import Vue from 'vue';
import { LOAD_STATE } from '@/store/shared';
import * as mutations from '@/store/mutation-types';
import CustomerActivity from '@/components/SubscriptionAnalytics/CustomerActivity.vue';
import DailyBreakdown from '@/components/SubscriptionAnalytics/DailyBreakdown.vue';

export default Vue.extend({
  name: 'AnalyticsDashboard',
  components: {
    DailyBreakdown,
    CustomerActivity,
  },
  data() {
    return {
      LOAD_STATE,
    };
  },
});
